import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {IconButton} from "@spg/component_library";
import chevronIcon from "../../../images/chevron.svg";

/**
 * A widget to select the dataset index to display.
 */
function TopicContentViewerSelection(props: {
  datasetIndex: number;
  setDatasetIndex: React.Dispatch<React.SetStateAction<number>>;
  datasetCount: number;
}) {
  const intl = useIntl();

  return (
    <div className="topicContentViewerSelection">
      <div className="topicContentViewerSelectionRow">
        <IconButton
          idBase={"topicContentViewerSelectionButtonPrevious"}
          onClick={() => props.setDatasetIndex((i) => i - 1)}
          disabled={props.datasetIndex === 0}
          iconProps={{
            href: chevronIcon + "#chevronLeft",
            title: intl.formatMessage({
              id: "topicContentViewer.selection.previous",
            }),
            strokeColor:
              props.datasetIndex === 0
                ? "var(--semTableColorWidgetHeadlines)"
                : "black",
          }}
          hoverColor="#ff3d00"
        />
        <div className="topicContentViewerSelectionTime">
          <FormattedMessage id="topicContentViewer.selection.latest" />
        </div>
      </div>
      <div className="topicContentViewerSelectionRow">
        {new Array(props.datasetCount).fill("_").map((_, i) => (
          <button
            id={"topicContentViewerSelectionButton" + i}
            key={i}
            onClick={() => props.setDatasetIndex(i)}
            className={
              "topicContentViewerSelectionButton" +
              (i === props.datasetIndex ? " active" : "")
            }
            aria-label={intl.formatMessage(
              {
                id: "topicContentViewer.selection.set",
              },
              {set: i + 1},
            )}
          >
            {i + 1}
          </button>
        ))}
      </div>
      <div className="topicContentViewerSelectionRow">
        <div className="topicContentViewerSelectionTime">
          <FormattedMessage id="topicContentViewer.selection.older" />
        </div>
        <IconButton
          idBase={"topicContentViewerSelectionButtonNext"}
          onClick={() => props.setDatasetIndex((i) => i + 1)}
          disabled={props.datasetIndex === props.datasetCount - 1}
          iconProps={{
            href: chevronIcon + "#chevronRight",
            title: intl.formatMessage({
              id: "topicContentViewer.selection.next",
            }),
            strokeColor:
              props.datasetIndex === props.datasetCount - 1
                ? "var(--semTableColorWidgetHeadlines)"
                : "black",
          }}
          hoverColor="#ff3d00"
        />
      </div>
    </div>
  );
}

export {TopicContentViewerSelection};
